/**
 * Application keyboard shortcuts
 */

//
// Do not follow "Angular 1 Style Guide" from @john_papa here
// https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md#style-y240
// It was written without es6 modules in mind
// https://medium.com/@bluepnume/dependency-injection-in-angular-isn-t-worth-it-more-lessons-learned-from-scaling-paypal-checkout-2189ec9c21a0
//

import Mousetrap from 'mousetrap'
import 'mousetrap_dictionary'

/**
 * mwAppKeyboardShortcuts run entry point
 *
 * @class mwAppKeyboardShortcuts
 * @memberof mwApp
 * @see mwApp
 *
 * @ngdoc run
 * @name mwApp.run:mwAppKeyboardShortcuts
 */
/* @ngInject */
export default function mwAppKeyboardShortcuts ($state, authSvc, notifySvc) {
  Mousetrap.bind({

    // search
    '/': function () {
      var searchBar = document.getElementById('_searchBar')
      if (searchBar) {
        searchBar.focus()
      }
      return false
    },

    // go to menu item
    'g': function () {
      var goBar = document.getElementById('_goBar')
      if (goBar) {
        goBar.value = ''
        goBar.focus()
      }
      return false
    },

    // logout
    'q q q': function () {
      authSvc.doLogout()
        .finally(
          () => {
            notifySvc.clear()
            $state.go('login')
          }
        )
    }

  })
}
